import { render, staticRenderFns } from "./PartyManagementView.vue?vue&type=template&id=4e5c1ecf&scoped=true&"
import script from "./PartyManagementView.vue?vue&type=script&lang=js&"
export * from "./PartyManagementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c1ecf",
  null
  
)

export default component.exports